<template><div><h1 id="ereignisauswertung-nach-attributen-kopf" tabindex="-1"><a class="header-anchor" href="#ereignisauswertung-nach-attributen-kopf"><span>Ereignisauswertung nach Attributen: Kopf</span></a></h1>
<p>Ereignisauswertung nach Attributen: Kopf — Identifikation und Beschreibung der Auswertung</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Enthält die Kopfdaten der <RouteLink to="/referenz/refstat/ft.refstat.adrereigattribut.html" title="Ereignisauswertung nach Merkmalen">Ereignisauswertung nach Attributen</RouteLink>.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Ereignisauswertung nach Merkmalen</code></p>
<h2 id="daten" tabindex="-1"><a class="header-anchor" href="#daten"><span>Daten</span></a></h2>
<dl>
<dt>Code</dt>
<dd>Frei definierbarer Code für die Identifikation der Auswertung</dd>
<dt>Beschreibung</dt>
<dd>Informationen zur Auswertung.</dd>
<dt>Benutzer</dt>
<dd>Erfasser der Auswertung. Wird automatisch eingetragen.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refstat/ft.refstat.adrereigattribut.html" title="Ereignisauswertung nach Merkmalen">Ereignisauswertung nach Attributen</RouteLink></p>
</div></template>


